var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_473_5965)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 44C34.1503 44 44 34.1503 44 22C44 9.84974 34.1503 0 22 0C9.84974 0 0 9.84974 0 22C0 34.1503 9.84974 44 22 44Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_473_5965)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 13.5,
    width: 19,
    height: 17,
    rx: 2.5,
    stroke: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0882 25.1074H26.3235C27.2828 25.1074 27.7624 25.1074 28.1409 24.9525C28.6453 24.7458 29.0461 24.3495 29.2551 23.8508C29.4118 23.4766 29.4118 23.0024 29.4118 22.0539C29.4118 21.1053 29.4118 20.6311 29.2551 20.2569C29.0461 19.7582 28.6453 19.3618 28.1409 19.1552C27.7624 19.0003 27.2828 19.0003 26.3235 19.0003H18.0882C17.1289 19.0003 16.6493 19.0003 16.2709 19.1552C15.7665 19.3618 15.3657 19.7582 15.1567 20.2569C15 20.6311 15 21.1053 15 22.0539C15 23.0024 15 23.4766 15.1567 23.8508C15.3657 24.3495 15.7665 24.7458 16.2709 24.9525C16.6493 25.1074 17.1289 25.1074 18.0882 25.1074Z",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_473_5965"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_473_5965"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 21,
    fill: "white",
    transform: "matrix(0 -1 1 0 11 31)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/En.bbb3e018b2a3eb4ea60c2b6e54c20569.svg";
export { ForwardRef as ReactComponent };